import React, { useCallback } from 'react';
import { format, parseISO } from 'date-fns';
import { SettingsItemNavigate } from 'design-system';
import { IconBoldCalendar, IconHome } from 'design-system/icons';
import { formatAddress } from 'utils/formatting';
import { DOB_DISPLAY_FORMAT } from 'hooks/useDateTimePickerDOB';
import { useDateTimePicker, useUserAddress } from 'hooks';
import { OnboardingFlow } from 'utils/types/navigation';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { popToOrNavigate } from 'utils/navigationv6';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import { setPendingMovingDate } from '../reducers/creditScoreOnboarding';
const strings = {
    whenDidYouMoveHere: 'When did you move here?',
    defaultOption: 'Choose...',
    primaryAddress: 'Primary address',
};
const CreditScoreAddressSection = () => {
    const navigation = useMainStackNavigation();
    const dispatch = useAppDispatch();
    const { primaryAddress } = useUserAddress();
    const pendingPrimaryAddress = useAppSelector((state) => state.creditScoreOnboarding.pendingPrimaryAddress);
    const pendingMovingDate = useAppSelector((state) => state.creditScoreOnboarding.pendingMovingDate);
    const address = pendingPrimaryAddress || primaryAddress || undefined;
    // Tie the displayed date to the displayed address — when a new pending
    // address is set, its startDate (undefined) takes precedence so the row
    // prompts the user to pick a fresh date instead of showing the old one.
    const movingDate = pendingMovingDate || address?.startDate;
    const onPressAddress = useCallback(() => {
        if (primaryAddress?.kycStatus) {
            popToOrNavigate(navigation, 'CreditScoreReviewKYCAddress');
        }
        else if (address && !address.id) {
            navigation.navigate('AddressInputScreen', {
                address,
                flow: OnboardingFlow.CreditScore,
            });
        }
        else {
            navigation.navigate('AddressPostCodeScreen', {
                flow: OnboardingFlow.CreditScore,
            });
        }
    }, [primaryAddress, address]);
    const { showDateTimePicker } = useDateTimePicker({
        initialValue: movingDate ? parseISO(movingDate) : new Date(),
        maximumDate: new Date(),
        onSubmitDate: (date) => {
            dispatch(setPendingMovingDate(date.toISOString()));
        },
    });
    const displayMovingDate = movingDate
        ? format(parseISO(movingDate), DOB_DISPLAY_FORMAT)
        : null;
    if (!address)
        return null;
    return (<>
      <SettingsItemNavigate title={formatAddress(address)} description={strings.primaryAddress} icon={<IconHome gradientKey="peach"/>} onPress={onPressAddress}/>
      <SettingsItemNavigate onPress={showDateTimePicker} description={strings.whenDidYouMoveHere} icon={<IconBoldCalendar gradientKey="turquoise"/>} title={displayMovingDate || strings.defaultOption} isSelected={false}/>
    </>);
};
export default CreditScoreAddressSection;
